import API from "./restApi";
import { AxiosResponse } from "axios";

let config = require("../configuration/config");

export function apiGetMyShoppingItems(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/myshoppingitems`);
}

export function apiAddOrUpdateShoppingItem(formData): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/addorupdateShoppingItem`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiQuickUpdateShoppingItem(formData): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/quickUpdateShoppingItem`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}
